import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Config } from "../utility/config";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class TimeSheetProjectService {
  constructor(private http: HttpClient, private config: Config) {}

  saveProject(data): Observable<any> {
    const url =
      this.config.APIUrl +
      "Time_Sheet_Projects/SaveUpdateProjects?Login_Key=" +
      this.config.login_Key;
    return this.http
      .post(url, data, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }

  getAllProjects(): Observable<any> {
    const url =
      this.config.APIUrl +
      "Time_Sheet_Projects/GetProjects?Login_Key=" +
      this.config.login_Key;
    return this.http
      .get(url, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }

  GetProjectsById(Id: any): Observable<any> {
    const url =
      this.config.APIUrl +
      "Time_Sheet_Projects/GetProjectsById?Login_Key=" +
      this.config.login_Key +
      "&Id=" +
      Id;
    return this.http
      .get(url, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }
  DeleteProjects(Id: any): Observable<any> {
    const url =
      this.config.APIUrl +
      "Time_Sheet_Projects/DeleteProjects?Login_Key=" +
      this.config.login_Key +
      "&Id=" +
      Id;
    return this.http
      .delete(url, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }
}
